import { LANGUAGE } from './language';
import { ru } from './locales/ru';
import { en } from './locales/en';

export type Dictionary = typeof ru;

const DICTIONARIES: Record<typeof LANGUAGE, Dictionary> = { ru, en };

/** Словарь текущего языка: `tr.matches.title`, строки с параметрами — функции. */
export const tr: Dictionary = DICTIONARIES[LANGUAGE];

if (typeof document !== 'undefined') {
  document.documentElement.lang = LANGUAGE;
}

export { LANGUAGE, LOCALE, SUPPORTED_LANGUAGES, setLanguage } from './language';
export type { Language } from './language';
